import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { withStyles } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { animateScroll as scroll, scroller } from 'react-scroll'; // eslint-disable-line
import * as QueryString from 'query-string';
import { Helmet } from 'react-helmet';
import Geocode from 'react-geocode';

import NavBar from '../../nav/NavBarMapCollapse';
import MapComponent from './MapComponent';
import MapSearchPanel from './MapSearchPanel';
import ListComponent from './ListComponent';
import ListSearchPanel from './ListSearchPanel';
import { getClasses } from '../../../shared/requests/ClassRequests';
import MySnackbarContentWrapper from '../../../shared/snackbars/MySnackbarContentWrapper';

import loadGMaps from '../LoadGMaps';

import {
  days,
  startTimes,
  endTimes,
} from '../../../shared/Mappings';
import {
  convert12to24hourtime,
  validAttendanceTypeByCode,
  validLanguageByCode,
  validOrderingByCode,
  validClassTypeByCode,
} from '../../../shared/Helpers';
import {
  GOOGLE_MAPS_API_KEY,
} from '../../../shared/Constants';

const DEFAULT_ZOOM = 7;

const styles = theme => ({
  layout: {
    flexGrow: 1,
    display: 'flex',
  },
  content: {
    flexGrow: 1,
  },
  appBarSpacer: theme.mixins.toolbar,
  wrapperOpen: {
    width: '100%',
    [theme.breakpoints.up(1240)]: {
      paddingLeft: 420,
    },
    transition: theme.transitions.create('padding-left', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  wrapperClosed: {
    width: '100%',
    paddingLeft: 0,
    transition: theme.transitions.create('padding-left', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
});


class Finder extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      pageLoading: false,
      attendanceType: 'both',
      listView: true,
      open: true,
      niaclasses: [],
      classType: 'any',
      instructor: '',
      language: 'any',
      address: '',
      coords: {
        latitude: 45.5,
        longitude: -122.6,
      },
      zoom: DEFAULT_ZOOM,
      openWindow: 0,
      day: 0,
      startTime: 0,
      endTime: 0,
      userTimezone: moment.tz.guess(),
      page: 0,
      morePagesAvailable: true,
      ordering: 'time',
      showTimezoneField: false,
      pageSize: '20',
      expanded: false,
      queryHasChanged: false,
    };

    this.handleDrawerOpen = this.handleDrawerOpen.bind(this);
    this.handleDrawerClose = this.handleDrawerClose.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleViewToggle = this.handleViewToggle.bind(this);
    this.handleClassTypeChange = this.handleClassTypeChange.bind(this);
    this.handleLanguageChange = this.handleLanguageChange.bind(this);
    this.setCenter = this.setCenter.bind(this);
    this.handleLocationChange = this.handleLocationChange.bind(this);
    this.handleLocationSelect = this.handleLocationSelect.bind(this);
    this.getNiaClasses = this.getNiaClasses.bind(this);
    this.onOpenMapWindow = this.onOpenMapWindow.bind(this);
    this.onCloseMapWindow = this.onCloseMapWindow.bind(this);
    this.onResultClick = this.onResultClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.getNextPage = this.getNextPage.bind(this);
    this.handleStartTimeChange = this.handleStartTimeChange.bind(this);
    this.handleEndTimeChange = this.handleEndTimeChange.bind(this);
    this.handleDayChange = this.handleDayChange.bind(this);
    this.handleMakeQuery = this.handleMakeQuery.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleAttendanceTypeChange = this.handleAttendanceTypeChange.bind(this);
    this.handleTimezoneChange = this.handleTimezoneChange.bind(this);
    this.handleQueryChange = this.handleQueryChange.bind(this);
    this.handleResetSearch = this.handleResetSearch.bind(this);
    this.handleShowTimezoneFieldChange = this.handleShowTimezoneFieldChange.bind(this);
    this.handleOrderChange = this.handleOrderChange.bind(this);
    this.handleShowOnMap = this.handleShowOnMap.bind(this);
    this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
    this.handleAccordionChange = this.handleAccordionChange.bind(this);
    this.handleDummyQuery = this.handleDummyQuery.bind(this);
  }

  componentDidMount() {
    // Accepts these as URL params
    let {
      listView,
      instructor,
      address,
      attendanceType,
      classType,
      // day,
      // startTime,
      // endTime,
      language,
      ordering,
      // timezone,
      pageSize,
      coords,
      zoom,
    } = this.state;

    loadGMaps(() => {
      const query = QueryString.parse(this.props.location.search);

      if (query.list_view !== undefined) {
        listView = query.list_view === 'true';
      }
      instructor = query.instructor !== undefined ? query.instructor : instructor;
      attendanceType = validAttendanceTypeByCode(query.attendance_type) ? query.attendance_type : attendanceType;
      classType = validClassTypeByCode(query.class_type) ? query.class_type : classType;
      language = validLanguageByCode(query.language) ? query.language : language;
      ordering = validOrderingByCode(query.ordering) ? query.ordering : ordering;
      pageSize = query.page_size !== undefined ? query.page_size : pageSize;

      if (query.address !== undefined) {
        // LOCATION INPUT VIA URL PARAMS
        geocodeByAddress(query.address)
          .then((results) => {
            getLatLng(results[0])
              .then((latLng) => {
                coords = { latitude: latLng.lat, longitude: latLng.lng };
                zoom = DEFAULT_ZOOM;
                address = results[0].formatted_address;
                // have to put this here because timing of geocode and getlatlng functions
                this.getNiaClasses({
                  inListView: listView,
                  inInstructor: instructor,
                  inAddress: address,
                  inAttendanceType: attendanceType,
                  inClassType: classType,
                  inLanguage: language,
                  inOrdering: ordering,
                  inLat: coords.lat,
                  inLng: coords.lng,
                  inPageSize: pageSize,
                });
                this.setState({
                  listView,
                  instructor,
                  address,
                  attendanceType,
                  classType,
                  language,
                  ordering,
                  coords,
                  zoom,
                  pageSize,
                });
              }).catch(error => console.error('Error', error)); //TODO
          })
          .catch(error => console.error('Error', error)); // TODO
      // LOCATION ACCEPTED BY USER
      } else if (global.navigator.geolocation) {
        global.navigator.geolocation.getCurrentPosition(
          // SUCCESSFULLY GOT LOCATION AUTOMATICALLY
          (position) => {
            const mycoords = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            };
            // get address from coords
            Geocode.setApiKey(GOOGLE_MAPS_API_KEY);
            Geocode.setLanguage('en');
            Geocode.fromLatLng(position.coords.latitude, position.coords.longitude).then(
              (response) => {
                address = response.results[0].formatted_address;
                // console.log('got address: ', response.results[0]);
                this.getNiaClasses({
                  inListView: listView,
                  inInstructor: instructor,
                  inAttendanceType: attendanceType,
                  inClassType: classType,
                  inLanguage: language,
                  inOrdering: ordering,
                  inLat: mycoords.latitude,
                  inLng: mycoords.longitude,
                  inPageSize: pageSize,
                });
                // console.log('setting state with address: ', address);
                this.setState({
                  listView,
                  instructor,
                  address,
                  attendanceType,
                  classType,
                  language,
                  ordering,
                  coords: mycoords,
                  zoom: DEFAULT_ZOOM,
                  pageSize,
                });
              },
              (error) => {
                console.error(error);
              },
            );
          },
          // FAILED TO GET LOCATION AUTOMATICALLY
          (error) => {
            console.log(error);
            this.getNiaClasses({
              inListView: listView,
              inInstructor: instructor,
              inAddress: address,
              inAttendanceType: attendanceType,
              inClassType: classType,
              inLanguage: language,
              inOrdering: ordering,
              inLat: coords.latitude,
              inLng: coords.longitude,
              inPageSize: pageSize,
            });
            this.setState({
              listView,
              instructor,
              address,
              attendanceType,
              classType,
              language,
              ordering,
              coords,
              zoom: DEFAULT_ZOOM,
              pageSize,
            });
          },
        );
      } else {
        // LOCATION DENIED BY USER, DEFAULT
        console.log('Geolocation is not supported by this browser.');
        this.getNiaClasses({
          inListView: listView,
          inInstructor: instructor,
          inAddress: address,
          inAttendanceType: attendanceType,
          inClassType: classType,
          inLanguage: language,
          inOrdering: ordering,
          inLat: coords.lat,
          inLng: coords.lng,
          inPageSize: pageSize,
        });
        this.setState({
          listView,
          instructor,
          address,
          attendanceType,
          classType,
          language,
          ordering,
          coords,
          zoom,
          pageSize,
        });
      }
    });
  }

  onCloseMapWindow() {
    this.setState({
      openWindow: 0,
    });
  }

  onOpenMapWindow(niaclass) { // map marker clicked
    scroller.scrollTo('scrollto' + niaclass.id, {
      duration: 200,
      delay: 100,
      smooth: true,
      offset: -180,
      containerId: 'containerElement',
    });
    this.setState({
      openWindow: niaclass.id,
    });
  }

  onResultClick(id) {
    this.setState({
      openWindow: id,
      open: false,
    });
  }

  getNiaClasses({
    inAttendanceType = null,
    inLat = null,
    inLng = null,
    inClassType = null,
    inInstructor = null,
    inDay = null,
    inStartTime = null,
    inEndTime = null,
    inLanguage = null,
    inPage = null,
    inOrdering = null,
    inPageSize = null,
    inTimezone = null,
  }) {
    const {
      attendanceType,
      classType,
      day,
      startTime,
      endTime,
      page,
      niaclasses,
      coords,
      language,
      ordering,
      instructor,
      userTimezone,
      pageSize,
    } = this.state;

    let attendanceTypeToUse = inAttendanceType || attendanceType;
    if (attendanceTypeToUse === 'both') {
      attendanceTypeToUse = null;
    } else if (attendanceTypeToUse === 'online') {
      attendanceTypeToUse = true;
    } else {
      attendanceTypeToUse = false;
    }

    let latToUse = null;
    let lngToUse = null;
    const orderingToUse = inOrdering || ordering;
    latToUse = inLat || coords.latitude;
    lngToUse = inLng || coords.longitude;

    let classTypeToUse = inClassType || classType;
    if (classTypeToUse === 'any') {
      classTypeToUse = null;
    }

    let instructorToUse = inInstructor || instructor;
    if (instructorToUse === '') {
      instructorToUse = null;
    }

    let dayToUse = inDay !== null ? inDay : day;
    if (dayToUse === 0) {
      dayToUse = null;
    }

    let startTimeToUse = inStartTime !== null ? startTimes[inStartTime] : startTimes[startTime];
    if (startTimeToUse === 'Any Time') {
      startTimeToUse = null;
    } else {
      startTimeToUse = convert12to24hourtime(startTimeToUse);
    }

    let endTimeToUse = inEndTime !== null ? endTimes[inEndTime] : endTimes[endTime];
    if (endTimeToUse === 'Any Time') {
      endTimeToUse = null;
    } else {
      endTimeToUse = convert12to24hourtime(endTimeToUse);
    }

    let languageToUse = inLanguage || language;
    if (languageToUse === 'any') {
      languageToUse = null;
    }

    const pageToUse = inPage || 0;

    let pageSizeToUse = inPageSize || pageSize;
    // if (pageSizeToUse === 'all') {
    //   pageSizeToUse = 10000;
    // } else {
    //   pageSizeToUse = parseInt(pageSizeToUse, 10);
    // }
    pageSizeToUse = parseInt(pageSizeToUse, 10);

    let timezoneToUse = inTimezone || userTimezone;

    getClasses(
      attendanceTypeToUse,
      latToUse,
      lngToUse,
      classTypeToUse,
      instructorToUse,
      timezoneToUse,
      dayToUse,
      startTimeToUse,
      endTimeToUse,
      languageToUse,
      orderingToUse,
      pageToUse,
      pageSizeToUse,
    )
      .then((response) => {
        // console.log('got nia classes: ', response.data);
        this.setState({
          niaclasses: pageToUse !== page + 1 ? response.data : niaclasses.concat(response.data),
          loading: false,
          pageLoading: false,
          morePagesAvailable: response.data.length === pageSizeToUse,
          page: pageToUse,
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          snackbarOpen: true,
          snackbarVariant: 'error',
          snackbarMessage: 'Failed to load data.. please refresh the page',
        });
      });
  }

  setCenter(position) {
    const mycoords = {
      latitude: position.coords.latitude,
      longitude: position.coords.longitude,
    };
    // get nearest classes after center change
    this.getNiaClasses({
      inLat: mycoords.latitude,
      inLng: mycoords.longitude,
    });
    this.setState({
      loading: true,
      coords: mycoords,
      zoom: DEFAULT_ZOOM,
    });
  }

  getNextPage() {
    this.setState({ pageLoading: true });
    const {
      page,
      coords,
      pageSize,
    } = this.state;
    this.getNiaClasses({
      inLat: coords.latitude,
      inLng: coords.longitude,
      inPage: page + 1,
      inPageSize: pageSize,
    });
  }

  handleViewToggle(e) {
    // console.log('view toggle input: ', e.target.value);
    // TODO: do we want to change ordering when view changes?
    let { ordering } = this.state;
    if (e.target.checked) {
      ordering = 'location';
      this.getNiaClasses({ inOrdering: ordering });
    } else {
      ordering = 'time';
      this.getNiaClasses({ inOrdering: ordering });
    }
    this.setState({
      listView: !e.target.checked,
      ordering,
    });
  }

  handleLocationChange(address) {
    this.setState({ address });
  }

  handleLocationSelect(address) {
    const mycoords = {
      latitude: '',
      longitude: '',
    };
    geocodeByAddress(address)
      .then((results) => {
        this.setState({ address: results[0].formatted_address });
        getLatLng(results[0])
          .then((latLng) => {
            mycoords.latitude = latLng.lat;
            mycoords.longitude = latLng.lng;
            this.setState({
              loading: true,
              coords: mycoords,
              zoom: DEFAULT_ZOOM,
              ordering: 'location',
              // queryHasChanged: true,
            });
            this.getNiaClasses({
              inLat: mycoords.latitude,
              inLng: mycoords.longitude,
              inOrdering: 'location',
            });
          });
      })
      .catch(error => console.error('Error', error)); // TODO
  }

  handleDrawerOpen() {
    this.setState({ open: true });
  }

  handleDrawerClose() {
    this.setState({ open: false });
  }

  handleClose(e, reason) {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ snackbarOpen: false });
  }

  handleStartTimeChange(e) {
    // console.log('start time: ', e.target.value);
    // console.log('typeof start time: ', typeof(e.target.value));
    this.setState({
      // loading: true,
      startTime: parseInt(e.target.value, 10),
      queryHasChanged: true,
    });
    // this.getNiaClasses({
    //   inStartTime: parseInt(e.target.value, 10),
    //   inPage: 0,
    // });
  }

  handleEndTimeChange(e) {
    // console.log('start time: ', e.target.value);
    // console.log('typeof start time: ', typeof(e.target.value));
    this.setState({
      // loading: true,
      endTime: parseInt(e.target.value, 10),
      queryHasChanged: true,
    });
    // this.getNiaClasses({
    //   inEndTime: parseInt(e.target.value, 10),
    //   inPage: 0,
    // });
  }

  handleDayChange(e) {
    // if this gets set to any day, remove start and end time filters
    let { startTime, endTime } = this.state;
    if (e.target.value === '0') {
      startTime = 0;
      endTime = 0;
    }
    this.setState({
      // loading: true,
      day: parseInt(e.target.value, 10),
      startTime,
      endTime,
      queryHasChanged: true,
    });
    // this.getNiaClasses({
    //   inDay: parseInt(e.target.value, 10),
    //   inPage: 0,
    // });
  }

  handleClassTypeChange(e) {
    this.setState({
      // loading: true,
      classType: e.target.value,
      queryHasChanged: true,
    });
    // this.getNiaClasses({
    //   inClassType: e.target.value,
    //   inPage: 0,
    // });
  }

  handleLanguageChange(e) {
    // console.log('languageChange: ', e.target.value);
    this.setState({
      // loading: true,
      language: e.target.value,
      queryHasChanged: true,
    });
    // this.getNiaClasses({
    //   inLanguage: e.target.value,
    //   inPage: 0,
    // });
  }

  handleMakeQuery() {
    const { instructor } = this.state;
    // this.handleDrawerClose();
    this.setState({
      loading: true,
      queryHasChanged: false,
    });
    this.getNiaClasses({
      inInstructor: instructor,
    });
    // console.log('handlemakequery');
  }

  handleKeyDown(e) {
    if (e.keyCode === 13) {
      this.handleMakeQuery();
      // console.log('handlekeydown');
    }
  }

  handleQueryChange(e) {
    this.setState({
      instructor: e.target.value,
      queryHasChanged: true,
    });
  }

  handleResetSearch(view) {
    const { listView } = this.state;
    let attendanceType = 'inperson';
    if (listView) {
      attendanceType = 'online';
    }
    const d = new Date();
    const day = d.getDay();
    this.setState({
      attendanceType,
      instructor: '',
      address: '',
      classType: 0,
      day,
      startTime: 0,
      endTime: 0,
      language: 'any',
      userTimezone: moment.tz.guess(),
      showTimezoneField: false,
      queryHasChanged: true,
    });
    // this.getNiaClasses({
    //   inAttendanceType: attendanceType,
    //   inInstructor: '',
    //   inAddress: '',
    //   inClassType: '0',
    //   inDay: day,
    //   inStartTime: 0,
    //   inEndTime: 0,
    //   language: 'any',
    //   inUserTimezone: moment.tz.guess(),
    // });
  }

  handleTimezoneChange(event, value, reason) {
    // console.log('timezone: ', value);
    // this.getNiaClasses({ inTimezone: value ? value.code : '' });
    this.setState({
      userTimezone: value ? value.code : '',
      showTimezoneField: false,
      queryHasChanged: true,
    });
  }

  handleAttendanceTypeChange(e) {
    // console.log('attendance type: ', e.target.value);
    // this.getNiaClasses({ inAttendanceType: e.target.value });
    this.setState({
      attendanceType: e.target.value,
      queryHasChanged: true,
    });
  }

  handleShowTimezoneFieldChange(e) {
    this.setState({ showTimezoneField: true });
  }

  handleOrderChange(e) {
    // this.getNiaClasses({ inOrdering: e.target.value });
    this.setState({
      ordering: e.target.value,
      queryHasChanged: true,
    });
  }

  handleShowOnMap(classId) {
    this.setState({
      listView: false,
      openWindow: classId,
    });
  }

  handlePageSizeChange(inSize) {
    // this.getNiaClasses({
    //   inPageSize: inSize,
    // });
    this.setState({
      pageSize: inSize,
      queryHasChanged: true,
    });
  }

  handleAccordionChange(e) {
    const { expanded } = this.state;
    this.setState({
      expanded: !expanded,
    });
  }

  handleDummyQuery(e) {
    e.preventDefault();
  }

  render() {
    const { classes } = this.props;
    const {
      attendanceType,
      listView,
      coords,
      zoom,
      niaclasses,
      snackbarOpen,
      snackbarVariant,
      snackbarMessage,
      address,
      openWindow,
      open,
      loading,
      pageLoading,
      morePagesAvailable,
      startTime,
      endTime,
      day,
      classType,
      instructor,
      userTimezone,
      language,
      ordering,
      showTimezoneField,
      pageSize,
      expanded,
      queryHasChanged,
    } = this.state;
    return (
      <div className={classes.layout}>

        <Helmet>
          <title>Nia Class Finder | Dance Fitness, Yoga, Meditation and More</title>
          <meta name="description" content="Nia's class finder helps you find a wide range of holistic dance fitness classes for all levels, including beginners and seniors. Find classes today!" />
          <meta name="keywords" content="dance, fitness, classes, live, yoga, classes, online" />
        </Helmet>

        {/* NAVBAR */}
        <NavBar
          open={open}
          handleDrawerOpen={this.handleDrawerOpen}
        />
        <div className={open ? classes.wrapperOpen : classes.wrapperClosed}>
          { listView
            ? (
              <React.Fragment>
                <ListSearchPanel
                  open={open}
                  handleDrawerClose={this.handleDrawerClose}
                  handleDrawerOpen={this.handleDrawerOpen}
                  checked={!listView}
                  handleViewToggle={this.handleViewToggle}
                  listItems={niaclasses}
                  handleClassTypeChange={this.handleClassTypeChange}
                  currentClassType={classType}
                  startTime={startTime}
                  handleStartTimeChange={this.handleStartTimeChange}
                  endTime={endTime}
                  handleEndTimeChange={this.handleEndTimeChange}
                  currentDay={day}
                  handleDayChange={this.handleDayChange}
                  handleResetSearch={this.handleResetSearch}
                  instructor={instructor}
                  handleQueryChange={this.handleQueryChange}
                  timezone={userTimezone}
                  handleTimezoneChange={this.handleTimezoneChange}
                  handleMakeQuery={this.handleMakeQuery}
                  loading={loading}
                  handleKeyDown={this.handleKeyDown}
                  attendanceType={attendanceType}
                  handleAttendanceTypeChange={this.handleAttendanceTypeChange}
                  language={language}
                  handleLanguageChange={this.handleLanguageChange}
                  showTimezoneField={showTimezoneField}
                  handleShowTimezoneFieldChange={this.handleShowTimezoneFieldChange}
                  ordering={ordering}
                  handleOrderChange={this.handleOrderChange}
                  pageSize={pageSize}
                  handlePageSizeChange={this.handlePageSizeChange}
                  handleDummyQuery={this.handleDummyQuery}
                  address={address}
                  handleLocationChange={this.handleLocationChange}
                  handleLocationSelect={this.handleLocationSelect}
                  queryHasChanged={queryHasChanged}
                />
                <ListComponent
                  loading={loading}
                  pageLoading={pageLoading}
                  niaclasses={niaclasses}
                  attendanceType={attendanceType}
                  userTimezone={userTimezone}
                  currentDay={days[day]}
                  getNextPage={this.getNextPage}
                  morePagesAvailable={morePagesAvailable}
                  ordering={ordering}
                  handleShowOnMap={this.handleShowOnMap}
                />
              </React.Fragment>
            )
            : (
              <React.Fragment>
                <MapSearchPanel
                  open={open}
                  handleDrawerClose={this.handleDrawerClose}
                  address={address}
                  listItems={niaclasses}
                  handleLocationChange={this.handleLocationChange}
                  handleLocationSelect={this.handleLocationSelect}
                  onResultClick={this.onResultClick}
                  active={openWindow}
                  checked={!listView}
                  handleViewToggle={this.handleViewToggle}
                  loading={loading}
                  pageLoading={pageLoading}
                  getNextPage={this.getNextPage}
                  morePagesAvailable={morePagesAvailable}
                  startTime={startTime}
                  endTime={endTime}
                  handleStartTimeChange={this.handleStartTimeChange}
                  handleEndTimeChange={this.handleEndTimeChange}
                  currentDay={day}
                  handleDayChange={this.handleDayChange}
                  currentClassType={classType}
                  handleClassTypeChange={this.handleClassTypeChange}
                  attendanceType={attendanceType}
                  handleAttendanceTypeChange={this.handleAttendanceTypeChange}
                  handleResetSearch={this.handleResetSearch}
                  language={language}
                  handleLanguageChange={this.handleLanguageChange}
                  ordering={ordering}
                  handleOrderChange={this.handleOrderChange}
                  pageSize={pageSize}
                  handlePageSizeChange={this.handlePageSizeChange}
                  expanded={expanded}
                  handleAccordionChange={this.handleAccordionChange}
                  instructor={instructor}
                  handleQueryChange={this.handleQueryChange}
                  handleKeyDown={this.handleKeyDown}
                  handleMakeQuery={this.handleMakeQuery}
                  queryHasChanged={queryHasChanged}
                />
                <div className={classes.content}>
                  <div className={classes.appBarSpacer} />
                  {/* MAP */}
                  <MapComponent
                    googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places"
                    loadingElement={<div style={{ height: 'calc(100vh - 64px)' }} />} // the calc(100vh - 64px) is making room for the appbar
                    containerElement={<div style={{ height: 'calc(100vh - 64px)' }} />}
                    mapElement={<div style={{ height: 'calc(100vh - 64px)' }} />}
                    coords={coords}
                    attendanceType={attendanceType}
                    zoom={zoom}
                    niaclasses={niaclasses}
                    onOpenMapWindow={this.onOpenMapWindow}
                    onCloseMapWindow={this.onCloseMapWindow}
                    openWindow={openWindow}
                    loading={loading}
                  />
                </div>
              </React.Fragment>
            )
          }
          {/* SNACKBAR */}
          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            open={snackbarOpen}
            autoHideDuration={5000}
            onClose={this.handleClose}
          >
            <MySnackbarContentWrapper
              onClose={this.handleClose}
              variant={snackbarVariant}
              message={snackbarMessage}
            />
          </Snackbar>
        </div>
      </div>
    );
  }
}

Finder.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Finder);
